import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Divider } from '@components/divider';
import { Addon } from '@domain/addon';
import { calculateAddonPrice } from '@utils/calculate-booking-price';
import { formatCurrency } from '@utils/price-formatter/price-formatter';

export interface AddOnsSummaryProps {
  currency: string;
  addons: Addon[];
  quantity: number;
  isVisible: boolean;
}
export const AddOnsSummary = ({ currency, addons, quantity, isVisible }: AddOnsSummaryProps) => {
  const { t } = useTranslation();
  if (!isVisible) return null;

  const formatAddonName = (addon: Addon) => (quantity > 1 ? `${quantity} x ${addon.displayName}` : addon.displayName);
  return (
    <>
      <p className='text-primary text-subtitle-m text-left col-span-full'>{t('addons:addOnSectionTitle')}</p>
      {addons.map((addon: Addon) => (
        <Fragment key={addon.id}>
          <p className='text-secondary text-body-s sm:text-body-m text-left truncate dark:text-gray-500'>
            {formatAddonName(addon)}
          </p>
          <p className='text-secondary text-body-s sm:text-body-m text-right dark:text-gray-500'>
            {formatCurrency({
              number: addon.fixedPrice.amount,
              currency,
            })}
          </p>
        </Fragment>
      ))}
      {quantity > 1 && (
        <>
          <Divider className='col-span-full py-0 mt-1 mb-0' />
          <p className='text-tertiary text-subtitle-m text-left'>{t('offers:subtotal')}</p>
          <p className='text-tertiary text-subtitle-m text-right'>
            {formatCurrency({
              number: calculateAddonPrice({ addons, quantity }),
              currency,
            })}
          </p>
        </>
      )}
    </>
  );
};
